import { Button } from '../../common/Button';
import { AppleIcon } from '../../../assets/icons';
import styles from './CTASection.module.css';

export const CTASection = () => {
  return (
    <section className={styles.ctaSection}>
      <div className={styles.ctaContent}>
        <h2>
          Ready to <em>see</em> what you hear?
        </h2>
        <p>
          Download Solo Sense today and transform the way you experience conversations in spatial computing.
        </p>
        <div className={styles.ctaButtons}>
          <Button variant="primary" icon={<AppleIcon />} href="https://apps.apple.com/us/app/solosense/id6742793439">
            Download on App Store
          </Button>
        </div>
      </div>
    </section>
  );
};
